import randomItem from 'random-item';
import { HERO_CUISINES_BY_COUNTRY } from '../components/HomepageHeroCuisineImage';
import { HERO_SHAPE_COLORS } from '../components/HeroShape';
import {
  HOMEPAGE_FEATURED_CONTENT,
  HOMEPAGE_FILTER_SELECTED,
  HOMEPAGE_FILTER_CLEAR,
  HOMEPAGE_HERO_CUISINE_IMAGE,
  HOMEPAGE_HERO_SHAPE_COLOR,
} from './types';

export function getHomepageFeaturedContent() {
  return (dispatch, getState) => {
    const { country, locale } = getState().request;
    return dispatch({
      type: HOMEPAGE_FEATURED_CONTENT,
      endpoint: `/orderapp/v2/featured_homepage_content?tld=${country.tld}&locale=${locale}`,
    });
  };
}

export function clickFeaturedCollection({ name, id }) {
  return {
    type: HOMEPAGE_FILTER_SELECTED,
    payload: {
      tags: id,
      name,
    },
  };
}

export function clickFeaturedRestaurant({ name, id }) {
  return {
    type: HOMEPAGE_FILTER_SELECTED,
    payload: {
      menu_group_uname: id,
      name,
    },
  };
}

export function clearSelectedFilter() {
  return {
    type: HOMEPAGE_FILTER_CLEAR,
  };
}

export function setHomepageHeroCuisineImage() {
  return (dispatch, getState) => {
    const { country } = getState().request;
    const heroCuisineImage = randomItem(HERO_CUISINES_BY_COUNTRY[country.tld]);

    return dispatch({
      type: HOMEPAGE_HERO_CUISINE_IMAGE,
      payload: { heroCuisineImage },
    });
  };
}

export function setHomepageHeroShapeColor() {
  return (dispatch) => {
    const heroShapeColor = randomItem(Object.keys(HERO_SHAPE_COLORS));

    return dispatch({
      type: HOMEPAGE_HERO_SHAPE_COLOR,
      payload: { heroShapeColor },
    });
  };
}
